import type { AutomationConfig, ApprovalRequest } from '@/lib/types';
import type { APPayload, APSummary } from './types';
import { COLUMNS_QUEUE, COLUMNS_HISTORY } from './columns';
import { APInvoiceDetailPanel } from './DetailPanel';
import { HistoryFilters } from './HistoryFilters';
import { APBulkGrnRefreshAction } from './APBulkGrnRefreshAction';

type APRequest = ApprovalRequest<APPayload, APSummary>;

export const APPurchaseInvoice: AutomationConfig<APRequest> = {
  slug: 'ap-purchase-invoice',
  displayName: 'AP Purchase Invoice',
  department: 'Finance',
  icon: 'Receipt',
  queueColumns: COLUMNS_QUEUE,
  historyColumns: COLUMNS_HISTORY,
  DetailComponent: APInvoiceDetailPanel,
  HistoryFiltersComponent: HistoryFilters,
  QueueActionsComponent: APBulkGrnRefreshAction,
  queueQueryParamKeys: ['bucket', 'view'],
  historyQueryParamKeys: [
    'vendor',
    'po_no',
    'grn_no',
    'invoice_no',
    'status',
    'bucket',
    'processed_from',
    'processed_to',
  ],
  quickFilters: [
    {
      key: 'needs-supplier',
      label: 'Needs supplier',
      tab: 'open',
      params: { bucket: 'SUPPLIER_NOT_FOUND,SUPPLIER_AMBIGUOUS' },
    },
    {
      key: 'needs-grn',
      label: 'Needs GRN',
      tab: 'open',
      params: { bucket: 'GRN_NOT_FOUND' },
    },
    {
      key: 'awaiting-grn-approval',
      label: 'Awaiting GRN approval',
      tab: 'open',
      params: { bucket: 'GRN_UNAPPROVED' },
    },
    {
      key: 'multiple-grns',
      label: 'Multiple GRNs',
      tab: 'open',
      params: { bucket: 'MULTIPLE_GRNS' },
    },
    {
      key: 'exp-reb-review',
      label: 'Exp/Reb review',
      tab: 'open',
      params: { bucket: 'EXP_REB_REVIEW' },
    },
    {
      key: 'grn-split-unsupported',
      label: 'GRN split',
      tab: 'open',
      params: { bucket: 'GRN_DETAIL_SPLIT_UNSUPPORTED' },
    },
    {
      key: 'tax-review',
      label: 'Tax review',
      tab: 'open',
      params: { bucket: 'TAX_MISMATCH_REVIEW' },
    },
    {
      key: 'date-review',
      label: 'Date review',
      tab: 'open',
      params: { bucket: 'DATE_REVIEW' },
    },
    {
      key: 'parse-error',
      label: 'Could not read',
      tab: 'open',
      params: { view: 'parse_error' },
      facetKey: 'parse_error',
    },
    {
      key: 'post-failed',
      label: 'Post failed',
      tab: 'open',
      params: { view: 'post_failed' },
      facetKey: 'post_failed',
    },
    {
      key: 'posted-today',
      label: 'Posted today',
      tab: 'history',
      params: { processed_from: '$today', processed_to: '$today' },
      facetKey: 'posted_today',
    },
    {
      key: 'duplicates',
      label: 'Duplicates',
      tab: 'history',
      params: { bucket: 'DUPLICATE' },
    },
    {
      key: 'rejected',
      label: 'Rejected',
      tab: 'history',
      params: { bucket: 'REJECTED' },
    },
  ],
};

export { APInvoiceDetailPanel } from './DetailPanel';
export { ServiceInvoiceModal } from './ServiceInvoiceModal';
export { classifyType } from './classifier';
export { COLUMNS_QUEUE, COLUMNS_HISTORY } from './columns';
export type { APPayload, APSummary } from './types';
